<template>
    <button
        type="button"
        class="btn btn-light btn-sm font-weight-bolder dm-btn-wizard p-2"
        @click="discardSubmissionPrompt()"
        :disabled="discarding"
    >
        <span v-if="discarding">
            {{ translate("Discarding") }}
            <span class="spinner spinner-track spinner-dark spinner-sm ml-2"></span>
        </span>
        <span v-else>{{ translate("Discard") }}</span>
    </button>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapState } from "pinia";

export default {
    data() {
        return {
            discarding: false,
        };
    },

    computed: {
        ...mapState(useSubmissionWizardStore, ["submission_id"]),
    },

    methods: {
        discardSubmissionPrompt() {
            var self = this;
            this.$swal({
                title: self.translate("Discard Submission?"),
                text: self.translate(
                    "This will delete this submission and any data you may have already entered for it",
                ),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText:
                    "<i class='icon-lg las la-trash'></i> " +
                    self.translate("Yes, delete it"),
                showCancelButton: true,
                cancelButtonText: self.translate("No, I changed my mind"),
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: "btn btn-default",
                },
            }).then((result) => {
                if (result.value) {
                    self.discardSubmission();
                } else {
                    self.$swal({
                        title: self.translate("Cancelled"),
                        text: self.translate("You did not delete the manuscript"),
                        icon: "info",
                        confirmButtonText: self.translate("Ok"),
                        customClass: {
                            confirmButton: "btn btn-light-success",
                        },
                    });
                }
            });
        },

        discardSubmission() {
            this.discarding = true;
            var self = this;
            axios
                .delete("/api/author/submissions/" + self.submission_id)
                .then(function (response) {
                    self.$swal({
                        title: self.translate("Deleted"),
                        text: self.translate("You've successfully discarded your submission"),
                        icon: "success",
                        confirmButtonText: self.translate("Ok"),
                        customClass: {
                            confirmButton: "btn btn-light-success",
                        },
                    }).then(() => {
                        window.location.href = "/author";
                    });
                })
                .catch(function () {
                    window.location.href = "/author";
                });
        },
    },
};
</script>
